import { Box } from "@mui/material";
import HubspotForm from "react-hubspot-form";
import LoadingSpinner from "../LoadingSpinner";

const HubspotContactForm = () => {
  return (
    <HubspotForm
      portalId={process.env.REACT_APP_HUBSPOT_PORTAL_ID}
      formId={process.env.REACT_APP_HUBSPOT_FORM_ID}
      loading={
        <Box
          sx={{
            width: "100%",
            height: "100%",
            textAlign: "center",
            padding: { xs: "10rem 0", md: "20rem 0" },
          }}
        >
          <LoadingSpinner />
        </Box>
      }
    />
  );
};

export default HubspotContactForm;
